import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

import './ShareViaEmailDialog.scss';

import { isValidEmail } from '../../utils/utils';
import { shareViaEmailExcelFile } from '../../services/userService';

const ShareViaEmailDialog = ({ generateExcel, open, onClose, fileName }) => {
  const [emails, setEmails] = useState(['']);
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleAddEmailAddress = () => {
    setEmails([...emails, '']);
  };

  const handleRemoveEmailAddress = (index) => {
    setEmails(emails.filter((email, i) => i !== index));
  };

  const handleEmailAddressChange = (index, value) => {
    setEmails(
      emails.map((email, i) => (i === index ? value : email))
    );
  };

  const validateEmails = () => {
    const valid = emails.every((email) => isValidEmail(email));
    setIsValid(valid);
  };

  const handleShareViaEmail = async (event) => {
    event.preventDefault();
    if (!isValid) return;
    try {
      setIsLoading(true);
      const workbook = await generateExcel();
      // Export to binary array
      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const file = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      await shareViaEmailExcelFile({
        file,
        emails,
        fileName
      });
      setEmails([''])
      toast.success("File shared successfully!");
      onClose();
    } catch (error) {
      console.error('Error in sharing file:', error);
      toast.warning("Error sharing file. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return <Modal
    size="md"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    show={open}
    onHide={onClose}
    backdrop="static"
    keyboard={false}
    className="modal-height"
  >
    <Modal.Header closeButton>
      <Modal.Title>Share Via Email</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form className='d-flex flex-column justify-content-between' style={{ height: '100%' }} onSubmit={handleShareViaEmail}>
        <div>
          {emails.map((email, index) => (
            <div key={index} className="email-address-input">
              <label>
                <span className="form-heading">Email Address {index + 1}:</span>
                <input
                  type="email"
                  value={email}
                  onChange={(event) => {
                    handleEmailAddressChange(index, event.target.value);
                    validateEmails();
                  }}
                  className="form-control"
                  required
                />
              </label>
              <button
                type="button"
                className="remove-button"
                onClick={() => handleRemoveEmailAddress(index)}
              >
                Remove
              </button>
            </div>
          ))}
          <button type="button" className="add-button" onClick={handleAddEmailAddress}>
            Add Email Address
          </button>
          <br />
        </div>
        <div>
          <button
            type="submit"
            className="share-button mb-1"
            disabled={emails?.length === 0 || !isValid || isLoading}
          >
            {
              isLoading 
              ?
                <div className="d-flex justify-content-center">
                  <div className="loader-sm loader-color-white"></div>
                </div>
              :
                "Share"
            }
          </button>
        </div>
      </form>
    </Modal.Body>
  </Modal>
};

export default ShareViaEmailDialog;